<template>
  <li class="card mt-5">
    <button class="no-styles iconclose close" @click="remove(index)"></button>
    <h3 class="card-header">
      <FavoriteButton
        :track="track"
        :index="index"
        :shouldRemove="shouldRemove"
        @removeItem="remove"
      />
      <a v-bind:href="url" target="_blank">{{ name }}</a>
    </h3>

    <div>
      <span
        v-for="(artist, idx) in artists"
        :key="artist.idindex"
        class="card-text"
      >
        <button class="artist-text" @click="getInfo(artist)">
          {{ artist.name }}
        </button>
        <span v-if="idx < artists.length - 1">|</span>
      </span>
    </div>

    <div v-if="event">
      <span class="card-text">
        <!-- <a :href="event.url" target="_blank">{{ event.short_title }}</a>
        on {{ event.datetime_local }}
        <p>{{ event.venue.name_v2 }}</p>
        <button
          class="actions-item iconmap"
          @click="onOpenMapModal(event)"
        ></button> -->
        {{ event.name }} on <br />
        {{ date }}
        <button
          class="actions-item iconmap"
          @click="onOpenMapModal(event)"
        ></button>
      </span>
    </div>
  </li>
</template>

<script>
import FavoriteButton from "@/components/FavoriteButton.vue";
export default {
  name: "MusicCard",
  components: { FavoriteButton },
  props: ["track", "name", "artists", "index", "id", "event", "shouldRemove"],
  computed: {
    date() {
      const date = new Date(this.event.startDate);
      var options = {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true
      };
      // Format the date
      var formattedDate = date.toLocaleString("en-US", options);
      return formattedDate;
    },
    url() {
      return `https://open.spotify.com/track/${this.id}`;
    }
  },

  methods: {
    remove: function(index) {
      this.$emit("removeItem", index);
    },

    onOpenMapModal(event) {
      this.$emit("openMapModal", event);
    },

    getInfo(artistName) {
      this.$emit("getInfo", artistName);
    },
    getRowStyle: function(a) {
      if (a.close_approach_data.length == 0) {
        return {
          border: "solid 2px red",
          color: "red"
        };
      }
    },
    isMissingData: function(a) {
      return a.close_approach_data.length == 0;
    }
  }
};
</script>

<style>
.card:hover .close {
  display: block;
  right: 8px;
  font-size: 12px;
}
.card-text {
  font-size: 0.8em;
  margin-top: 5px;
}

button {
  background: none;
  box-shadow: none;
  border: none;
  font-size: 18px;
  margin: 0;
}

.actions-item {
  padding: 8px;
  color: #c53526;
  font-size: 15px;
}

.actions-item--bigger {
  font-size: 20px;
}

.event-item {
  padding: 0 10px;
}

.artist-text {
  font-size: 14px;
  text-align: left;
  padding: 8px;
}

@media screen and (min-width: 320px) and (max-width: 400px) {
  .card {
    flex: 0 0 100%;
  }
}

@media screen and (min-width: 401px) and (max-width: 850px) {
  .card {
    flex: 0 0 calc(50% - 15px);
  }
}
</style>
